export default __webpack_public_path__ + "static/media/japanese-icon.d0a0c506.svg";